import { render, staticRenderFns } from "./LetterNew.vue?vue&type=template&id=9aa987f6"
import script from "./LetterNew.vue?vue&type=script&lang=js"
export * from "./LetterNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports